module.exports = __webpack_public_path__ + "img/main-mobile.709d5d1.webp";